import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { DiscriminatorRequest } from '../../requests/risk-classification/discriminator.request';
import { CreateDiscriminatorResponse } from '../../responses/risk-classification/create-discriminator.response';
import { GetDiscriminatorStructResponse } from '../../responses/risk-classification/get-discriminator-struct.response';

@Injectable({
  providedIn: 'root'
})
export class DiscriminatorService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  GetDiscriminatorByIdDiscriminator(idDiscriminator: number): Observable<GetDiscriminatorStructResponse> {
    let uri = `Discriminator/idDiscriminator/${idDiscriminator}`

    return this.httpClient.get<GetDiscriminatorStructResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  CreateDiscriminator(body: DiscriminatorRequest): Observable<CreateDiscriminatorResponse> {
    let uri = `Discriminator`

    return this.httpClient.post<CreateDiscriminatorResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  UpdateDiscriminator(body: DiscriminatorRequest): Observable<ReturnStruct> {
    let uri = `Discriminator`

    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  DeleteDiscriminator(idDiscriminator: number): Observable<ReturnStruct> {
    let uri = `Discriminator/idDiscriminator/${idDiscriminator}`

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
